import React from "react";
import Nav from "../Nav";
import "./HomeScreen.css";
import Banner from "../Banner";
import Row from "../Row";
import requests from "../requests";

function HomeScreen() {
  return (
    <div className="HomeScreen">
      <Nav />
      <Banner />
      <Row
        fetchUrl={requests.fetchComedyMovies}
        title="Netflix-Originals"
        isLarge
      />
      {/* <Row fetchUrl={requests.fetchNetflixOriginals} title="Netflix-originals" /> */}
      <Row fetchUrl={requests.fetchComedyMovies} title="Comedy Movies" />
      <Row fetchUrl={requests.fetchHorrorMovies} title="Horror Movies" />
      <Row fetchUrl={requests.fetchComedyMovies} title="trending" />
      <Row fetchUrl={requests.fetchDocumentaries} title="Documeteries" />
    </div>
  );
}

export default HomeScreen;
